!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("react"), require("prop-types"), require("classnames"));else if ("function" == typeof define && define.amd) define(["react", "prop-types", "classnames"], t);else {
    var _ = "object" == typeof exports ? t(require("react"), require("prop-types"), require("classnames")) : t(e.react, e["prop-types"], e.classnames);
    for (var r in _) ("object" == typeof exports ? exports : e)[r] = _[r];
  }
}(window, function (__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__4__) {
  return function (e) {
    var t = {};
    function _(r) {
      if (t[r]) return t[r].exports;
      var a = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(a.exports, a, a.exports, _), a.l = !0, a.exports;
    }
    return _.m = e, _.c = t, _.d = function (e, t, r) {
      _.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, _.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, _.t = function (e, t) {
      if (1 & t && (e = _(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (_.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var a in e) _.d(r, a, function (t) {
        return e[t];
      }.bind(null, a));
      return r;
    }, _.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return _.d(t, "a", t), t;
    }, _.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, _.p = "", _(_.s = 10);
  }([function (e, t) {
    e.exports = __WEBPACK_EXTERNAL_MODULE__0__;
  }, function (e, t) {
    e.exports = __WEBPACK_EXTERNAL_MODULE__1__;
  }, function (e, t, _) {
    "use strict";

    t.a = {
      Core: "_1ncNYh11bEgDHaKrVgg3AR",
      curr: "r7OsZg7yeZ9DuLfw2IEiG",
      left: "_1dMDT1m5zXlSxArCEZKgPw",
      right: "_3NJbiiVgEGpfWA-RGgRm8e",
      top: "_23O3tTmRuQSjtOTfZ1a6U7",
      bottom: "_3ToZVinlQtbzwB-45jlba6"
    };
  }, function (e, t) {
    e.exports = function (e) {
      if (!e.webpackPolyfill) {
        var t = Object.create(e);
        t.children || (t.children = []), Object.defineProperty(t, "loaded", {
          enumerable: !0,
          get: function () {
            return t.l;
          }
        }), Object.defineProperty(t, "id", {
          enumerable: !0,
          get: function () {
            return t.i;
          }
        }), Object.defineProperty(t, "exports", {
          enumerable: !0
        }), t.webpackPolyfill = 1;
      }
      return t;
    };
  }, function (e, t) {
    e.exports = __WEBPACK_EXTERNAL_MODULE__4__;
  }, function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    (function (module) {
      var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1),
        prop_types__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__),
        react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0),
        react__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__),
        enterModule;
      function _defineProperty(e, t, _) {
        return t in e ? Object.defineProperty(e, t, {
          value: _,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = _, e;
      }
      enterModule = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.enterModule : void 0, enterModule && enterModule(module);
      var __signature__ = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default.signature : function (e) {
        return e;
      };
      class Animated extends react__WEBPACK_IMPORTED_MODULE_1__.PureComponent {
        constructor() {
          super(...arguments), _defineProperty(this, "state", {
            selected: this.props.selected
          }), _defineProperty(this, "rafCallback", e => {
            if (!this.startTime) return this.startTime = e, void (this.id = requestAnimationFrame(this.rafCallback));
            const t = e - this.startTime,
              _ = this.startSelected + this.direction * t / this.props.animationDuration;
            (1 === this.direction ? _ < this.props.selected : _ > this.props.selected) ? (this.turn(_), this.id = requestAnimationFrame(this.rafCallback)) : this.turn(this.props.selected);
          });
        }
        turn(e) {
          this.setState({
            selected: e
          }, () => {
            const {
              onTurn: t
            } = this.props;
            t instanceof Function && t(e);
          });
        }
        componentDidUpdate(e) {
          if (this.props.animationDuration !== e.animationDuration || this.props.selected !== e.selected) {
            if (cancelAnimationFrame(this.id), this.startSelected = this.state.selected, this.startTime = 0, this.direction = Math.sign(this.props.selected - this.state.selected), !this.direction) return;
            if (!this.props.animationDuration) return void this.turn(this.props.selected);
            this.id = requestAnimationFrame(this.rafCallback);
          }
        }
        render() {
          const {
            animationDuration: e,
            flippingPages: t,
            onTurn: _,
            selected: r,
            willChange: a,
            ...o
          } = this.props;
          return Object(react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(t, {
            selected: this.state.selected,
            willChange: this.state.selected !== r || a,
            ...o
          });
        }
        __reactstandin__regenerateByEval(key, code) {
          this[key] = eval(code);
        }
      }
      _defineProperty(Animated, "propTypes", {
        animationDuration: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number,
        flippingPages: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.element.isRequired,
        onTurn: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func,
        selected: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number.isRequired,
        willChange: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool
      }), _defineProperty(Animated, "defaultProps", {
        animationDuration: 500,
        willChange: !1
      });
      const _default = Animated;
      var reactHotLoader, leaveModule;
      __webpack_exports__.a = _default, reactHotLoader = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default : void 0, reactHotLoader && (reactHotLoader.register(Animated, "Animated", "/home/naman/Code/flipping-pages/src/Animated.js"), reactHotLoader.register(_default, "default", "/home/naman/Code/flipping-pages/src/Animated.js")), leaveModule = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.leaveModule : void 0, leaveModule && leaveModule(module);
    }).call(this, __webpack_require__(3)(module));
  }, function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    (function (module) {
      var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4),
        classnames__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__),
        prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1),
        prop_types__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__),
        react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0),
        react__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__),
        _Core_sass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2),
        enterModule;
      function _extends() {
        return _extends = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var _ = arguments[t];
            for (var r in _) Object.prototype.hasOwnProperty.call(_, r) && (e[r] = _[r]);
          }
          return e;
        }, _extends.apply(this, arguments);
      }
      function _defineProperty(e, t, _) {
        return t in e ? Object.defineProperty(e, t, {
          value: _,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = _, e;
      }
      enterModule = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.enterModule : void 0, enterModule && enterModule(module);
      var __signature__ = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default.signature : function (e) {
        return e;
      };
      class Core extends react__WEBPACK_IMPORTED_MODULE_2__.PureComponent {
        getTurn(e) {
          let t = e % 1;
          return t < 0 && t++, t >= .5 && t--, t *= 2, t;
        }
        getRotation(e, t) {
          return t * ("horizontal" === e ? -90 : 90);
        }
        getTransform(e, t) {
          return "rotate".concat("horizontal" === e ? "Y" : "X", "(").concat(this.getRotation(e, t), "deg)");
        }
        render() {
          const {
              children: e,
              className: t,
              direction: _,
              rootRef: r,
              selected: a,
              shadowBackground: o,
              willChange: i,
              ...n
            } = this.props,
            s = react__WEBPACK_IMPORTED_MODULE_2__.Children.toArray(e),
            l = s[Math.round(a)],
            d = s[Math.round(a) - 1],
            p = s[Math.round(a) + 1],
            c = this.getTurn(a),
            u = {},
            E = {},
            h = {},
            f = {
              background: o
            },
            P = {},
            M = {},
            O = {
              background: o
            };
          return c < 0 ? (u.opacity = 0, h.transform = this.getTransform(_, c), f.opacity = -c, O.opacity = 0) : c > 0 ? (u.opacity = 0, M.transform = this.getTransform(_, c), O.opacity = c, f.opacity = 0) : (E.visibility = "hidden", h.visibility = "hidden", P.visibility = "hidden", M.visibility = "hidden"), i && (u.willChange = "opacity", E.willChange = "visibility", h.willChange = "visibility, transform", f.willChange = "opacity", P.willChange = "visibility", M.willChange = "visibility, transform", O.willChange = "opacity"), react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", _extends({
            ref: r,
            className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(_Core_sass__WEBPACK_IMPORTED_MODULE_3__.a.Core, t)
          }, n), react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
            className: _Core_sass__WEBPACK_IMPORTED_MODULE_3__.a.curr,
            style: u
          }, l), react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
            className: _Core_sass__WEBPACK_IMPORTED_MODULE_3__.a["horizontal" === _ ? "left" : "top"],
            style: E,
            "aria-hidden": "true"
          }, react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
            className: _Core_sass__WEBPACK_IMPORTED_MODULE_3__.a.clipper
          }, d)), react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
            className: _Core_sass__WEBPACK_IMPORTED_MODULE_3__.a["horizontal" === _ ? "left" : "top"],
            style: h,
            "aria-hidden": "true"
          }, react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
            className: _Core_sass__WEBPACK_IMPORTED_MODULE_3__.a.clipper
          }, l), react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
            className: _Core_sass__WEBPACK_IMPORTED_MODULE_3__.a.shadow,
            style: f
          })), react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
            className: _Core_sass__WEBPACK_IMPORTED_MODULE_3__.a["horizontal" === _ ? "right" : "bottom"],
            style: P,
            "aria-hidden": "true"
          }, react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
            className: _Core_sass__WEBPACK_IMPORTED_MODULE_3__.a.clipper
          }, p)), react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
            className: _Core_sass__WEBPACK_IMPORTED_MODULE_3__.a["horizontal" === _ ? "right" : "bottom"],
            style: M,
            "aria-hidden": "true"
          }, react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
            className: _Core_sass__WEBPACK_IMPORTED_MODULE_3__.a.clipper
          }, l), react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
            className: _Core_sass__WEBPACK_IMPORTED_MODULE_3__.a.shadow,
            style: O
          })));
        }
        __reactstandin__regenerateByEval(key, code) {
          this[key] = eval(code);
        }
      }
      _defineProperty(Core, "propTypes", {
        direction: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(["horizontal", "vertical"]).isRequired,
        rootRef: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,
        selected: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number.isRequired,
        shadowBackground: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        willChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
      }), _defineProperty(Core, "defaultProps", {
        shadowBackground: "rgba(0,0,0,0.25)",
        willChange: !1
      });
      const _default = Core;
      var reactHotLoader, leaveModule;
      __webpack_exports__.a = _default, reactHotLoader = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default : void 0, reactHotLoader && (reactHotLoader.register(Core, "Core", "/home/naman/Code/flipping-pages/src/Core.js"), reactHotLoader.register(_default, "default", "/home/naman/Code/flipping-pages/src/Core.js")), leaveModule = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.leaveModule : void 0, leaveModule && leaveModule(module);
    }).call(this, __webpack_require__(3)(module));
  }, function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    (function (module) {
      var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4),
        classnames__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__),
        prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1),
        prop_types__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__),
        react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0),
        react__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__),
        _PointerControl_sass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9),
        enterModule;
      function _defineProperty(e, t, _) {
        return t in e ? Object.defineProperty(e, t, {
          value: _,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = _, e;
      }
      enterModule = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.enterModule : void 0, enterModule && enterModule(module);
      var __signature__ = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default.signature : function (e) {
        return e;
      };
      class PointerControl extends react__WEBPACK_IMPORTED_MODULE_2__.PureComponent {
        constructor() {
          super(...arguments), _defineProperty(this, "state", {
            down: !1,
            selected: this.props.selected
          }), _defineProperty(this, "handlePointerDown", e => {
            const {
              onPointerDown: t,
              onSwipeStart: _
            } = this.props;
            !this.down && this.state.selected === this.props.selected && _(e) && (this.setState({
              down: !0
            }), this.startSelected = this.state.selected, this.id = e.pointerId, this.x = e.clientX, this.startX = this.x, this.lastX = this.x, this.y = e.clientY, this.startY = this.y, this.lastY = this.y, this.time = e.timeStamp, this.lastTime = this.time), t && t(e);
          }), _defineProperty(this, "handlePointerMove", e => {
            this.state.down && e.pointerId === this.id && (this.lastX = this.x, this.lastY = this.y, this.x = e.clientX, this.y = e.clientY, this.lastTime = this.time, this.time = e.timeStamp, this.updateSelectedWhenDown());
          }), _defineProperty(this, "handlePointerUp", e => {
            this.state.down && e.pointerId === this.id && (this.setState({
              down: !1
            }), this.updateSelectedWhenUp());
          });
        }
        getTurn() {
          let e = "horizontal" === this.props.direction ? this.startX - this.x : this.startY - this.y;
          this.props.reverse && (e *= -1);
          return e / this.props.swipeLength;
        }
        updateSelectedWhenDown() {
          const e = this.getTurn();
          let t = this.props.selected + e;
          t = Math.max(t, this.props.selected - 1), t = Math.min(t, this.props.selected + 1);
          const _ = react__WEBPACK_IMPORTED_MODULE_2__.Children.count(this.props.children);
          t < 0 ? t = -this.props.onOverSwipe(-t) : t + 1 > _ && (t = this.props.onOverSwipe(t + 1 - _) + _ - 1), this.setState({
            selected: t
          });
        }
        updateSelectedWhenUp() {
          this.setState({
            selected: this.props.selected
          });
          const e = this.getTurn();
          let t = ("horizontal" === this.props.direction ? this.lastX - this.x : this.lastY - this.y) / (this.time - this.lastTime);
          this.props.reverse && (t *= -1);
          let _ = this.props.selected;
          e ? Math.abs(e) < .5 ? Math.abs(t) >= this.props.thresholdSpeed && Math.sign(t) === Math.sign(e) && (_ += Math.sign(t)) : (Math.abs(t) < this.props.thresholdSpeed || Math.sign(t) !== Math.sign(e)) && (_ += Math.sign(e)) : Math.abs(t) >= this.props.thresholdSpeed && (_ += Math.sign(t)), _ = Math.max(_, 0), _ = Math.min(_, react__WEBPACK_IMPORTED_MODULE_2__.Children.count(this.props.children) - 1);
          const {
            onSelectedChange: r
          } = this.props;
          r && r(_);
        }
        componentDidUpdate(e) {
          this.props.selected !== e.selected && (this.state.down ? (this.setState({
            down: !1
          }), this.updateSelectedWhenUp()) : this.setState({
            selected: this.props.selected
          }));
        }
        componentDidMount() {
          addEventListener("pointermove", this.handlePointerMove), addEventListener("pointerup", this.handlePointerUp), addEventListener("pointercancel", this.handlePointerUp);
        }
        componentWillUnmount() {
          removeEventListener("pointermove", this.handlePointerMove), removeEventListener("pointerup", this.handlePointerUp), removeEventListener("pointercancel", this.handlePointerUp);
        }
        render() {
          const {
            animationDuration: e,
            className: t,
            flippingPages: _,
            onOverSwipe: r,
            onPointerDown: a,
            onSelectedChange: o,
            onSwipeStart: i,
            selected: n,
            swipeLength: s,
            thresholdSpeed: l,
            ...d
          } = this.props;
          return Object(react__WEBPACK_IMPORTED_MODULE_2__.cloneElement)(_, {
            animationDuration: this.state.down ? 0 : this.props.animationDuration,
            className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(_PointerControl_sass__WEBPACK_IMPORTED_MODULE_3__.a.flippingPages, t),
            onPointerDown: this.handlePointerDown,
            selected: this.state.selected,
            willChange: this.state.down,
            ...d
          });
        }
        __reactstandin__regenerateByEval(key, code) {
          this[key] = eval(code);
        }
      }
      _defineProperty(PointerControl, "propTypes", {
        animationDuration: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        direction: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(["horizontal", "vertical"]).isRequired,
        flippingPages: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.element.isRequired,
        onOverSwipe: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        onSelectedChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        onSwipeStart: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        reverse: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
        selected: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number.isRequired,
        swipeLength: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        thresholdSpeed: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number
      }), _defineProperty(PointerControl, "defaultProps", {
        animationDuration: 400,
        onOverSwipe: e => e / 4,
        onSwipeStart: e => e.isPrimary,
        reverse: !1,
        swipeLength: 400,
        thresholdSpeed: .1
      });
      const _default = PointerControl;
      var reactHotLoader, leaveModule;
      __webpack_exports__.a = _default, reactHotLoader = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default : void 0, reactHotLoader && (reactHotLoader.register(PointerControl, "PointerControl", "/home/naman/Code/flipping-pages/src/PointerControl.js"), reactHotLoader.register(_default, "default", "/home/naman/Code/flipping-pages/src/PointerControl.js")), leaveModule = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.leaveModule : void 0, leaveModule && leaveModule(module);
    }).call(this, __webpack_require__(3)(module));
  }, function (e, t, _) {
    "use strict";

    (function (e) {
      var r,
        a = _(1),
        o = _.n(a),
        i = _(0);
      (r = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.enterModule : void 0) && r(e);
      "undefined" != typeof reactHotLoaderGlobal && reactHotLoaderGlobal.default.signature;
      const n = Object(i.memo)(e => {
        const {
            children: t,
            flippingPages: _,
            reverse: r,
            selected: a,
            ...o
          } = e,
          n = i.Children.toArray(t);
        return Object(i.cloneElement)(_, {
          selected: r ? n.length - a - 1 : a,
          ...o
        }, r ? n.reverse() : n);
      });
      n.propTypes = {
        flippingPages: o.a.element.isRequired,
        reverse: o.a.bool,
        selected: o.a.number.isRequired
      }, n.defaultProps = {
        reverse: !1
      };
      const s = n;
      var l, d;
      t.a = s, (l = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default : void 0) && (l.register(n, "Reverse", "/home/naman/Code/flipping-pages/src/Reverse.js"), l.register(s, "default", "/home/naman/Code/flipping-pages/src/Reverse.js")), (d = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.leaveModule : void 0) && d(e);
    }).call(this, _(3)(e));
  }, function (e, t, _) {
    "use strict";

    t.a = {
      flippingPages: "_2BXhR9UHrnlpm_nHq7-PdZ"
    };
  }, function (e, t, _) {
    "use strict";

    _.r(t), function (e) {
      var r,
        a = _(0),
        o = _.n(a),
        i = _(5),
        n = _(6),
        s = _(7),
        l = _(8);
      function d() {
        return d = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var _ = arguments[t];
            for (var r in _) Object.prototype.hasOwnProperty.call(_, r) && (e[r] = _[r]);
          }
          return e;
        }, d.apply(this, arguments);
      }
      (r = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.enterModule : void 0) && r(e);
      "undefined" != typeof reactHotLoaderGlobal && reactHotLoaderGlobal.default.signature;
      const p = Object(a.memo)(e => {
        const {
          children: t,
          ..._
        } = e;
        return o.a.createElement(s.a, d({
          flippingPages: o.a.createElement(i.a, {
            selected: 0,
            flippingPages: o.a.createElement(l.a, {
              selected: 0,
              flippingPages: o.a.createElement(n.a, {
                direction: "horizontal",
                selected: 0
              })
            })
          })
        }, _), t);
      });
      p.propTypes = Object.assign({}, n.a.propTypes, l.a.propTypes, i.a.propTypes, s.a.propTypes), delete p.propTypes.flippingPages, delete p.propTypes.willChange, p.defaultProps = Object.assign({}, n.a.defaultProps, l.a.defaultProps, i.a.defaultProps, s.a.defaultProps), delete p.defaultProps.willChange;
      const c = p;
      var u, E;
      t.default = c, (u = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default : void 0) && (u.register(p, "FlippingPages", "/home/naman/Code/flipping-pages/src/FlippingPages.js"), u.register(c, "default", "/home/naman/Code/flipping-pages/src/FlippingPages.js")), (E = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.leaveModule : void 0) && E(e);
    }.call(this, _(3)(e));
  }]);
});